import React, { Component } from "react";
import csv_icn from "./../../../img/reports_card/csv_icn.svg";
import download_img from "./../../../img/reports_card/download.svg";
import xlsx_icn from "./../../../img/reports_card/ic_XLS.svg";
import share_img from "./../../../img/reports_card/share.svg";
import zip_icn from "./../../../img/reports_card/zip-report.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import AxiosClient from "../../../Network/AxiosClient";
import "./../styles/report.css";

class MerchantReport extends Component {
  constructor(props) {
    super(props);
    this.state = { status: this.props.generationStatus };
  }

  render() {
    const compact = this.props.isCompactView;
    const isGeneratable = this.props.report.isGeneratable ? true : false;

    const isDownloadDisabled =
      this.props.fetching || this.props.generationStatus === "Pending";

    return (
      <>
        <div
          className={compact ? "report report-compact" : "report"}
          style={{ height: 170 }}
        >
          <div className="heading">
            <img
              className="xlsx-icon"
              src={
                this.props.report.file_type === "csv"
                  ? csv_icn
                  : this.props.report.file_type === "zip"
                  ? zip_icn
                  : xlsx_icn
              }
              alt="icon"
            />
            <div
              className="info"
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div className="title">{this.props.report.name}</div>

              {isGeneratable && this.props.generationStatus === "Pending" && (
                <div className="report-status">
                  Generating report, please wait
                  <CircularProgress size={10} style={{ marginLeft: 7 }} />
                </div>
              )}
            </div>
          </div>
          <div className="action">
            <div className="button-group">
              {!compact && (
                <button className="share-button" disabled>
                  <img src={share_img} alt="share" />
                  Share
                </button>
              )}

              <button
                className="download-button"
                style={{
                  opacity: isDownloadDisabled ? 0.6 : 1,
                  cursor: isDownloadDisabled ? "no-drop" : "pointer",
                }}
                disabled={isDownloadDisabled}
                onClick={this.props.callBack}
              >
                <img
                  src={download_img}
                  alt="download"
                  style={{ marginRight: compact ? 5 : 0 }}
                />
                Download
              </button>
            </div>
            {this.props.fetching && (
              <div
                className="progress"
                style={{
                  borderRadius: "0px 0px 8px 8px",
                  margin: "0px",
                }}
              >
                <div className="indeterminate"></div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default MerchantReport;
